module.exports = __webpack_public_path__ + "img/pv_year_red.a369d31b.svg";